(function () {
    "use strict";

    angular.module("app").factory("addressesApi", AddressesApiFactory);

    AddressesApiFactory.$inject = [
        "apiClientFactory",
    ];
    function AddressesApiFactory(
        apiClientFactory,
    ) {
        return {
            updateBranch: (organisationDossierPublicId, addressPublicId) => apiClientFactory.put(`api/organisations/${organisationDossierPublicId}/addresses/${addressPublicId}`),
        };
    }
})();
